module.exports = __webpack_public_path__ + "static/img/row1.b773ba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/mobile/row1.png
// module id = uDev
// module chunks = 12